<template>
  <b-form-group label="Data" label-for="liquidation-date-filter">
    <b-input-group>
      <b-form-input
        id="liquidation-date-filter"
        type="date"
        v-model="localValue"
      />

      <b-input-group-append>
        <b-button variant="secondary" @click="applyFilter">
          <i class="fas fa-search "></i>
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BButton } from 'bootstrap-vue';

export default {
  name: 'DateFilter',
  components: { BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BButton },

  props: {
    value: {
      type: String,
      default: () => new Date().toISOString().substr(0, 10),
    },
  },

  data() {
    return {
      localValue: this.value,
    };
  },

  methods: {
    applyFilter() {
      this.$emit('input', this.localValue); 
      this.$emit('search', this.localValue); 
    },
  },
};
</script>
